/**
 * useSubscriptionConfig Hook
 *
 * Fetches active subscription config for current workspace.
 * Used to display current dimension-based subscription limits.
 */

import { useQuery } from '@tanstack/react-query';
import { getSubscriptionConfig, type SubscriptionConfig } from '@/lib/api/subscription-pricing';

export function useSubscriptionConfig() {
  return useQuery<SubscriptionConfig>({
    queryKey: ['subscription-config'],
    queryFn: getSubscriptionConfig,
    retry: 2,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
